import {RefObject, useLayoutEffect} from 'react'

export default function useStickyHScroll(
    enabled: boolean,
    scrollerRef: RefObject<HTMLDivElement>,
    barRef: RefObject<HTMLDivElement>,
    deps: any[] = []
) {
    useLayoutEffect(() => {
        if (!enabled) return;

        const scroller = scrollerRef.current;
        const bar = barRef.current;
        if (!scroller || !bar) return;

        const inner = bar.firstElementChild as HTMLDivElement | null;
        if (!inner) return;

        const table = scroller.querySelector('table') as HTMLElement | null;

        const sync = () => {
            const w = Math.max(
                scroller.scrollWidth,
                table?.scrollWidth || 0,
                scroller.clientWidth + 1 // защита от граничного кейса
            );
            if (inner.style.width !== w + 'px') inner.style.width = w + 'px';
            if (bar.scrollLeft !== scroller.scrollLeft) bar.scrollLeft = scroller.scrollLeft;
        };

        const onS = () => { bar.scrollLeft = scroller.scrollLeft; };
        const onB = () => { scroller.scrollLeft = bar.scrollLeft; };

        scroller.addEventListener('scroll', onS, {passive: true});
        bar.addEventListener('scroll', onB, {passive: true});

        const ro = new ResizeObserver(sync);
        ro.observe(scroller);
        if (table) ro.observe(table);

        // начальный рассчёт после layout
        requestAnimationFrame(() => requestAnimationFrame(sync));

        return () => {
            scroller.removeEventListener('scroll', onS);
            bar.removeEventListener('scroll', onB);
            ro.disconnect();
        };
    }, [enabled, ...deps]);
}
